import React from "react";
import styled, { css } from "styled-components";
import { Colors } from "../config";
import InputLabel from "./InputLabel";
import { uploadDocuments } from "../services/bookingServices";
import { Error } from "../config/StyledComponents";
import { useLoaderContext } from "../contexts/loaderContext";
const strokeIcon = require("../assets/images/Stroke.png");

const UploadDocument = ({
  label = "Upload Passport",
  value,
  onChange,
  disabled,
  name,
  helperText,
  index,
  selectedFileName,
}) => {
  let { setLoader } = useLoaderContext();
  const handleChange = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      console.log(file);
      getViewUrl(file);
    }
  };
  const getViewUrl = async (file) => {
    setLoader(true);
    try {
      let response = await uploadDocuments(file);
      console.log(response);
      if (response.status === 200) {
        setLoader(false);
        onChange(response.data.files[0]);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };

  const handleDelete = () => {
    onChange("");
  };

  return (
    <Wrapper>
      {label && (
        <InputLabel
          label={label}
          labelFontColor={Colors.coolGrey}
          labelFontSize="1.125rem"
          labelFontWeight="400"
          isRounded
        />
      )}
      <input
        type="file"
        id={`actual-btn${index}`}
        accept="image/jpeg,image/png,application/pdf"
        name={name}
        hidden
        onClick={(e) => (e.target.value = "")}
        onChange={handleChange}
        disabled={disabled}
      />
      <UploadDesignWrapper helperText={helperText}>
        <UploadButton htmlFor={`actual-btn${index}`} disabled={disabled}>
          Choose file
        </UploadButton>
      </UploadDesignWrapper>
      {helperText && <Error>{helperText}</Error>}
      {value && (
        <DeleteWrapper>
          <PdfName onClick={() => window.open(value, "_blank")}>
            {selectedFileName}
          </PdfName>
          <XImg src={strokeIcon} alt="x" onClick={handleDelete} />
        </DeleteWrapper>
      )}
    </Wrapper>
  );
};

export default UploadDocument;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const UploadDesignWrapper = styled.div`
  border: ${(props) =>
    props.helperText
      ? `1px solid ${Colors.red}`
      : `1px solid ${Colors.coolGrey}`};
  width: calc(100% - 1.4rem);
  border-radius: 2.5rem;
  padding: 1rem 1rem 1rem 0.4rem;
`;
const UploadButton = styled.label`
  background: ${Colors.brandTwo};
  border-radius: 2.5rem;
  padding: 0.625rem;
  font-weight: 500;
  font-size: 1rem;
  color: ${Colors.white};
  cursor: pointer;
  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;
const PdfName = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #22242c;
  cursor: pointer;
`;
const DeleteWrapper = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0.5rem;
  align-items: center;
`;
const XImg = styled.img`
  cursor: pointer;
`;
